/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { CaseActivityActorType } from './CaseActivityActorType';
import {
    CaseActivityActorTypeFromJSON,
    CaseActivityActorTypeFromJSONTyped,
    CaseActivityActorTypeToJSON,
    CaseActivityActorTypeToJSONTyped,
} from './CaseActivityActorType';

/**
 * 
 * @export
 * @interface CaseActivityEvent
 */
export interface CaseActivityEvent {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    event_type: string;
    /**
     * 
     */
    actor_type: CaseActivityActorType;
    /**
     * 
     */
    actor_user: StaffUserRef | null;
    /**
     * 
     */
    actor_participant_id: string | null;
    /**
     * 
     */
    participant_id: string | null;
    /**
     * 
     */
    request_id: string | null;
    /**
     * 
     */
    request_item_id: string | null;
    /**
     * 
     */
    document_id: string | null;
    /**
     * 
     */
    message_id: string | null;
    /**
     * 
     */
    occurred_at: Date;
}



/**
 * Check if a given object implements the CaseActivityEvent interface.
 */
export function instanceOfCaseActivityEvent(value: object): value is CaseActivityEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('event_type' in value) || value['event_type'] === undefined) return false;
    if (!('actor_type' in value) || value['actor_type'] === undefined) return false;
    if (!('actor_user' in value) || value['actor_user'] === undefined) return false;
    if (!('actor_participant_id' in value) || value['actor_participant_id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('request_id' in value) || value['request_id'] === undefined) return false;
    if (!('request_item_id' in value) || value['request_item_id'] === undefined) return false;
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    if (!('occurred_at' in value) || value['occurred_at'] === undefined) return false;
    return true;
}

export function CaseActivityEventFromJSON(json: any): CaseActivityEvent {
    return CaseActivityEventFromJSONTyped(json, false);
}

export function CaseActivityEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseActivityEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'event_type': json['event_type'],
        'actor_type': CaseActivityActorTypeFromJSON(json['actor_type']),
        'actor_user': StaffUserRefFromJSON(json['actor_user']),
        'actor_participant_id': json['actor_participant_id'],
        'participant_id': json['participant_id'],
        'request_id': json['request_id'],
        'request_item_id': json['request_item_id'],
        'document_id': json['document_id'],
        'message_id': json['message_id'],
        'occurred_at': (json['occurred_at'] == null ? json['occurred_at'] : parseDateTime(json['occurred_at'])),
    };
}

export function CaseActivityEventToJSON(json: any): CaseActivityEvent {
    return CaseActivityEventToJSONTyped(json, false);
}

export function CaseActivityEventToJSONTyped(value?: CaseActivityEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'event_type': value['event_type'],
        'actor_type': CaseActivityActorTypeToJSON(value['actor_type']),
        'actor_user': StaffUserRefToJSON(value['actor_user']),
        'actor_participant_id': value['actor_participant_id'],
        'participant_id': value['participant_id'],
        'request_id': value['request_id'],
        'request_item_id': value['request_item_id'],
        'document_id': value['document_id'],
        'message_id': value['message_id'],
        'occurred_at': value['occurred_at'] == null ? value['occurred_at'] : serializeDateTime(value['occurred_at']),
    };
}

